// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideber-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: #ffffff;

    width: 80px;
    overflow: hidden;

    z-index: 1200 !important;
    /*Default MUI Drawer z-index*/

    transition: width, 0.35s;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.sideber-wrapper:hover {
    width: 250px;
    transition: width, 0.4s;
}

`, "",{"version":3,"sources":["webpack://./src/Layout/Layout.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,yBAAyB;;IAEzB,WAAW;IACX,gBAAgB;;IAEhB,wBAAwB;IACxB,6BAA6B;;IAE7B,wBAAwB;IACxB,iDAAiD;AACrD;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B","sourcesContent":[".sideber-wrapper {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    background-color: #ffffff;\n\n    width: 80px;\n    overflow: hidden;\n\n    z-index: 1200 !important;\n    /*Default MUI Drawer z-index*/\n\n    transition: width, 0.35s;\n    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.sideber-wrapper:hover {\n    width: 250px;\n    transition: width, 0.4s;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
